import { type DeviceDetails } from '@service-initiation/tech-care-data-access-tech-care-services';

import { removeSingleQuotes } from './removeSingleQuotes';

const flattenDeviceDetailsAnalyticsRecursive = (
  deviceDetails: DeviceDetails,
  collection: string[] = []
): string[] =>
  deviceDetails.parent
    ? flattenDeviceDetailsAnalyticsRecursive(deviceDetails.parent, [
        removeSingleQuotes(deviceDetails.name),
        ...collection,
      ])
    : collection;

export const flattenDeviceDetailsAnalytics = (
  deviceDetails: DeviceDetails
): Record<string, string> =>
  flattenDeviceDetailsAnalyticsRecursive(deviceDetails).reduce(
    (acc, detail, index) => ({ ...acc, [`DeviceDetail${index + 1}`]: detail }),
    {}
  );
